const BACKGROUND_COLOR = {
  GREEN: "primary-green", // changed the key name from red to green as per the new design update. In prismic the value is still red for this variant will have to change the name in prismic too.
  STONE: "secondary-stone-200", // changed the key name from blue to stone as per the new design update. In prismic the value is still stone for this variant will have to change the name in prismic too.
  LIGHTGREEN: "secondary-green-700", // changed the key name from lightblue to lightgreen as per the new design update. In prismic the value is still lightblue for this variant will have to change the name in prismic too.
  LIGHTSTONE: "secondary-stone-50", // changed the key name from lightgrey to lightstone as per the new design update. In prismic the value is still light grey for this variant will have to change the name in  prismic too.
};

export const getBackgroundColor = (backgroundColor: string | null) => {
  switch (backgroundColor) {
    case "blue":
    case "Prosperity Stone 200 – Dark beige":
      return BACKGROUND_COLOR.STONE;

    case "light grey":
    case "Prosperity Stone 100 – Beige":
      return BACKGROUND_COLOR.LIGHTSTONE;

    case "light blue":
    case "Accounting Green 700 – Green":
      return BACKGROUND_COLOR.LIGHTGREEN;

    case "red":
    case "Accounting Green 950 – Dark green":
    default:
      return BACKGROUND_COLOR.GREEN;
  }
};
